<main class="c-main" role="main">
    <div class="c-page-home">
        <!--banner -->
        <div class="c-main-home">
            <div class="container"><span class="c-main-home__small"> {{ 'HomePortal.title1' | translate}} </span>
                <h2 class="c-main-home__title"> {{ 'HomePortal.title2' | translate}} <br> {{ 'HomePortal.title3' | translate}}</h2>
            </div>

        </div>
        <!--content-->
        <div class="container" align="center" style="padding: 80px;" *ngIf="!(ActiveModule.access_request_employee || ActiveModule.access_req_contractor || ActiveModule.access_req_exception || ActiveModule.new_access_card || ActiveModule.card_reposition || ActiveModule.all_request)">
            <div class="c-highlights rounded-3">
                <h2>{{ 'HomePortal.notModules-1' | translate }}</h2>
                <h3>{{ 'HomePortal.notModules-2' | translate }}</h3>

                <br>
                <label><p>{{ 'HomePortal.notModules-3' | translate }}<a style="color:#E65400" [routerLink]="['faq']"> {{ 'HomePortal.btnFAQ' | translate }}</a></p> </label>


            </div>
        </div>
        <div class="container" *ngIf="ActiveModule.access_request_employee || ActiveModule.access_req_contractor || ActiveModule.access_req_exception || ActiveModule.new_access_card || ActiveModule.card_reposition || ActiveModule.all_request">
            <!--highlights-->

            <div class="c-highlights">
                <div class="row row-custom justify-content-center ">
                    <div class="col-md-4 col-xs-12 align-self-center" *ngIf="ActiveModule.myAuthorisedAccesses || ActiveModule.myQualifications">
                        <!--self verification-->

                        <div class="c-highlights__item"><img style="height: auto; width: 314px" src="../assets/img/Mel10-1.jpg">
                            <h3 class="c-highlights__title"> {{ 'HomePortal.selfVerification' | translate }}</h3>
                            <ul>
                                <li style="cursor: pointer;" *ngIf="ActiveModule.myAuthorisedAccesses" [routerLink]="['my-authorised-accesses']"><a><i class="icon icon-arrow"></i></a><a>
                                {{ 'HomePortal.myAuthAccess' | translate }}
                                </a>
                                                    <p> {{ 'HomePortal.authAccessDescrip' | translate }}</p>
                                                </li>
                                                <li style="cursor: pointer;" *ngIf="ActiveModule.myQualifications" [routerLink]="['my-qualifications']"><a><i class="icon icon-arrow"></i></a><a>
                                {{ 'HomePortal.myAccessQualif' | translate }}
                                </a>
                                    <p> {{ 'HomePortal.accessQualifDescrip' | translate }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-4 col-xs-12 align-self-center" *ngIf="ActiveModule.access_request_employee || ActiveModule.access_req_contractor || ActiveModule.access_req_exception || ActiveModule.otherTemporaryAccess">

                        <div class="c-highlights__item "><img style="height: auto; width: 314px" src="../assets/img/Mel3-1.jpg">
                            <h3 class="c-highlights__title">{{ 'HomePortal.siteAccessRequest' | translate }} </h3>
                            <ul>
                                <li *ngIf="ActiveModule.access_request_employee" [routerLink]="['access-request/employee']" style="cursor: pointer;"><a><i  class="icon icon-arrow"></i></a><a><span
                                    >{{ 'HomePortal.employee' | translate }}</span><span
                                    class="c-highlights_excl"> </span></a>
                                    <p>{{ 'HomePortal.employeeDescrip' | translate }}</p>
                                </li>
                                <li *ngIf="ActiveModule.access_req_contractor" [routerLink]="['access-request/contractor']" style="cursor: pointer;"><a><i class="icon icon-arrow"></i></a><a><span
                                    >{{ 'HomePortal.contractor' | translate }}</span></a>
                                    <p> {{ 'HomePortal.contractorDescrip' | translate }} </p>
                                </li>
                                <li *ngIf="ActiveModule.otherTemporaryAccess" [routerLink]="['other-temporary-accesses']" style="cursor: pointer;"><a><i class="icon icon-arrow" style="cursor: pointer;"></i></a>
                                    <a> <span>{{ 'HomePortal.temporary' | translate }}</span></a>
                                    <p>{{ 'HomePortal.temporaryDescrip' | translate }}</p>
                                </li>
                                <li *ngIf="ActiveModule.access_req_exception" [routerLink]="['access-request/exception']" style="cursor: pointer;"><a><i class="icon icon-arrow" style="cursor: pointer;"></i></a>
                                    <a> <span>{{ 'HomePortal.exception' | translate }}</span><span class="c-highlights_excl"></span></a>
                                    <p>{{ 'HomePortal.exceptionDescrip' | translate }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-4 col-xs-12 align-self-center" *ngIf="ActiveModule.new_access_card || ActiveModule.card_reposition">
                        <!--item-->
                        <div class="c-highlights__item"><img style="height: auto; width: 314px" src="../assets/img/Spence2-1.jpg">
                            <h3 class="c-highlights__title">{{ 'HomePortal.cardIssuance' | translate }}</h3>
                            <ul>
                                <li *ngIf="ActiveModule.new_access_card" [routerLink]="['new-access-card']" style="cursor: pointer;"><a><i class="icon icon-arrow"></i></a>
                                    <a> <span>{{ 'HomePortal.newAccessCard' | translate }}</span><span class="c-highlights_excl"></span></a>
                                    <p>{{ 'HomePortal.newCardDescrip' | translate }}</p>
                                </li>
                                <li *ngIf="ActiveModule.card_reposition" style="cursor: pointer;" [routerLink]="['card-reposition']"><a><i class="icon icon-arrow"></i></a>
                                    <a> <span>{{ 'HomePortal.cardReplacement' | translate }}</span></a>
                                    <p>{{ 'HomePortal.cardReplacementDescrip' | translate }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--request-->
        <div class="c-request"  *ngIf="getModulesLength()>0"  >
            <div class="container">
                <h4 class="c-request__title">{{ 'HomePortal.recentRequests' | translate }}</h4>
                <table class="table table-bordered table-striped table-condensed" >
                    <thead>
                        <tr>
                            <th>
                                <p><span>{{'HomePortal.colReqNum' | translate}}</span></p>
                            </th>
                            <th>
                                <p> <span>{{'HomePortal.colType' | translate}}</span></p>

                            </th>
                            <th>
                                <p><span>{{'HomePortal.colStatus' | translate}}</span></p>
                            </th>
                            <th>
                                <p><span> {{'HomePortal.colRequestor' | translate}}</span></p>
                            </th>

                            <th>
                                <p><span> {{'HomePortal.colReqDate' | translate}}</span></p>
                            </th>
                            <th>
                                <p><span> {{'HomePortal.colDetails' | translate}}</span></p>
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of request">
                            <td style="text-align: center;">
                                <p>
                                    <strong>
                                            {{item.requestNumber}}
                                        </strong>
                                </p>
                            </td>
                            <td class="table__title-row">
                                <p>
                                    <strong *ngIf="item.type.Id == 1"> {{'HomePortal.employeeTable' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 2"> {{'HomePortal.contractorTable' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 3"> {{'HomePortal.visitorTable' | translate }} </strong>
                                    <strong *ngIf="item.type.Id == 4"> {{'HomePortal.exceptionTable' | translate }} </strong>
                                    <!-- <strong *ngIf="item.type==true"> {{'table-columns.new'| translate}} </strong>
                                        <strong *ngIf="item.type==false"> {{'table-columns.replacement'| translate}} </strong> -->
                                </p>
                            </td>

                            <td>

                                <i *ngIf="item.status.Name=='Pending'  || item.status.Name=='Pending by Facility' || item.status.Name=='Pending by SAR Approver' " class="icon icon-more"> </i>
                                <i *ngIf="item.status.Name=='Reject' || item.status.Name=='Rejected by Facilities' || item.status.Name=='Rejected by SAR Approver' || item.status.Name=='Terminated'" class="icon icon-close"> </i>
                                <i *ngIf="item.status.Name=='Approved' || item.status.Name=='Approved by Facilities' || item.status.Name=='Approved by SAR Approver'" class="icon icon-check"> </i>
                                <i *ngIf="item.status.Name=='Delegate'" class="icon icon-arrow" style=" transform: rotateY(180deg);">  </i>

                                <span *ngIf="item.status.Name=='Pending'">{{'HomePortal.pendingTable'| translate}} </span>
                                <span *ngIf="item.status.Name=='Pending by Facility'">{{'HomePortal.pendingFacilityTable'| translate}} </span>
                                <span *ngIf="item.status.Name=='Pending by SAR Approver'"> {{'HomePortal.pendingSarApproverTable'| translate}}</span>
                                <span *ngIf="item.status.Name=='Terminated'">{{'HomePortal.terminatedTable'| translate}} </span>

                                <span *ngIf="item.status.Name=='Delegate'">&nbsp; {{'HomePortal.DelegateTable'| translate}} </span>

                                <span *ngIf="item.status.Name=='Reject'">{{'HomePortal.rejectTable'| translate}} </span>
                                <span *ngIf="item.status.Name=='Rejected by Facilities'">{{'HomePortal.rejectFacilityTable'| translate}}</span>
                                <span *ngIf="item.status.Name=='Rejected by SAR Approver'">{{'HomePortal.rejectSarApproverTable'| translate}}</span>


                                <span *ngIf="item.status.Name=='Approved'">{{'HomePortal.approvedTable'| translate}} </span>
                                <span *ngIf="item.status.Name=='Approved by Facilities'">{{'HomePortal.approvedFacilityTable'| translate}} </span>
                                <span *ngIf="item.status.Name=='Approved by SAR Approver'">{{'HomePortal.approvedSarApproverTable'| translate}} </span>

                            </td>

                            <td style="text-align: center;">
                                <p> <strong> {{ item.requestorName }}  </strong> </p>
                            </td>
                            <td>
                                <p> <strong> {{ item.createdAt | date: 'dd/MM/yyyy'  }}  </strong> </p>
                            </td>

                            <td>
                                <div align="center">
                                    <p>
                                        <span class="table__mobile">{{'HomePortal.colDetails' | translate}}: </span>
                                        <a [routerLink]="['/access-list/records/', item.requestNumber ]">
                                            <img src="../assets/img/icn/ICONO/ARCHIVO.svg" alt="" title="{{'HomePortal.tooltipSeeDetails'| translate}}">
                                        </a>
                                    </p>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>
                <div class="c-request__action"><a class="btn btn--primary" [routerLink]="['access-list/records']"> {{'HomePortal.btnRequest'| translate }}</a></div>
                <br>
            </div>



        </div>
    </div>

</main>
<div class="c-highlights-policy" *ngIf="ActiveModule.policy_check_management || ActiveModule.access_list_approvers">
    <div class="container">
        <div class="row">
            <div class="col-md-6" *ngIf="ActiveModule.policy_check_management">
                <div class="c-highlights__item">
                    <h3 class="c-highlights-policy__title">{{ 'HomePortal.policyAccessManagement' | translate }}</h3>
                    <ul *ngIf="ActiveModule.policy_check_management">
                        <li> <a [routerLink]="['policy/checkManagement']">{{ 'HomePortal.checkPolicyAccess' | translate}}</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6" *ngIf="ActiveModule.access_list_approvers">
                <div class="c-highlights__item">
                    <h3 class="c-highlights-policy__title">{{ 'HomePortal.siteAccessApprover' | translate }}</h3>
                    <ul *ngIf="ActiveModule.access_list_approvers">
                        <li> <a [routerLink]="['access-list/approvers']">{{ 'HomePortal.listSiteAccessApprover' | translate }}s</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
